// src/components/CurrencySelector/CurrencySelector.jsx
import { useSelector, useDispatch } from 'react-redux';
import { setCurrency } from '../../Store/reducers/currencyReducer';
import { FormControl, Select, MenuItem, useTheme } from '@mui/material';

const CurrencySelector = () => {
    const dispatch = useDispatch();
    const currentCurrency = useSelector((state) => state.currency.selectedCurrency);
    const rates = useSelector((state) => state.currency.rates);
    const theme = useTheme();

    const handleChange = (e) => {
        dispatch(setCurrency(e.target.value));
    };

    return (
        <FormControl variant="outlined" size="small">
            <Select
                variant="outlined"
                value={currentCurrency}
                onChange={handleChange}
            >
                {Object.keys(rates).map((code) => (
                    <MenuItem key={code} value={code}>
                        {code}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default CurrencySelector;
